module.exports = __webpack_public_path__ + "67d94a8c1565c1180c9537fe98a448cd.png";